import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";

export default function TaxaInstalacao() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/planos?primeiro=1", { replace: true });
  }, [navigate]);

  return <Loading />;
}
